import React from "react";

import styles from "./Loading.module.css";
import AnimatedProjectLogo from "../../assets/SVGs/AnimatedProjectLogo/AnimatedProjectLogo";

export default function Loading() {
  return (
    <div className={styles.container}>
      <AnimatedProjectLogo className={styles.logo} />
      <h1>Loading...</h1>
      <p>Press the logo above to replay the animation.</p>
    </div>
  );
}
